import styled from "styled-components/macro";

export const Container = styled.div`
  display: block;

  width: 300px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: calc(100% + 15px);

  height: -moz-fit-content;
  height: -webkit-fit-content;
  height: fit-content;

  background: var(--grey-0);
  color: var(--context-menu-text);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 20px;
  bottom: -50px;
  text-align: center;
  line-height: 1.4em;
  z-index: 100000000;
  box-shadow: var(--default-drop-shadow);
  cursor: auto;

  div.text {
    background: var(--context-menu-text);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  a {
    display: inline !important;
    color: var(--grey-0) !important;

    text-decoration: underline !important;
    text-decoration-color: var(--grey-2) !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--grey-0);
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translate(-50%, 0);
  // transform: translate(50%, 0);
`;

export const Dismiss = styled.a`
  position: absolute;
  top: 6px;
  right: 6px;

  svg {
    stroke: var(--context-menu-text);
    width: 11px !important;
    height: 11px !important;
  }
`;
